import { render, staticRenderFns } from "./CustomerMetricsReport.vue?vue&type=template&id=d5dc5058&scoped=true&"
import script from "./CustomerMetricsReport.vue?vue&type=script&lang=js&"
export * from "./CustomerMetricsReport.vue?vue&type=script&lang=js&"
import style0 from "./CustomerMetricsReport.vue?vue&type=style&index=0&id=d5dc5058&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d5dc5058",
  null
  
)

export default component.exports